/**
 * "Relâmpago de hoje" (ela, 21/10/2026): janela(s) de hoje/amanhã por conta, quantas programadas, quantas candidatas
 * (e quantas na lista fixa), limite de vagas observado pelo robô. Dado do GET /api/promocoes/relampago.
 * Nada aqui é inventado: sem janela lida da API, o bloco diz "nenhuma relâmpago programada"; sem recusa observada,
 * "limite ainda não observado".
 */
import { useEffect, useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { fetchRelampago, type ResumoRelampago } from './promocoesService'
import { rotuloJanela } from './logic'
import { usePromo } from './ctx'
import { LARANJA, P, Panel } from './ui'

const NOME: Record<string, string> = { '777058595': 'ML Matriz', '3131364517': 'ML Extrema' }

export function RelampagoHoje() {
  const ctx = usePromo()
  const [r, setR] = useState<ResumoRelampago | null | undefined>(undefined)
  useEffect(() => {
    let vivo = true
    void fetchRelampago().then((x) => { if (vivo) setR(x) })
    return () => { vivo = false }
  }, [ctx.fila?.gerado_em])

  if (r === undefined) return null
  if (!r) return <Panel title="⚡ Relâmpago de hoje"><P>Serviço fora do ar: sem leitura das janelas da relâmpago.</P></Panel>
  const semLista = !r.lista_fixa.length
  return (
    <Panel title="⚡ Relâmpago de hoje" count={<span>{r.hoje.slice(8, 10)}/{r.hoje.slice(5, 7)}</span>}>
      <P>
        O robô liga a relâmpago na <b>conta inteira</b>: toda candidata que fecha o piso de relâmpago (geral ou o do grupo) no preço proposto pelo ML, 5 unidades (23/10/2026). Os grupos marcados como <b>lista fixa</b> vêm primeiro, na ordem em que você digitou; o robô para a janela quando o ML recusa por vagas.
        {r.so_lista_fixa ? <Box component="b" sx={{ color: LARANJA }}> ⚠ PROMO_RELAMPAGO_SO_LISTA=1 na VPS: só a lista fixa entra (regra de 21/10).</Box> : null}
      </P>
      {semLista
        ? <Typography sx={{ fontSize: 12.5, mb: 1 }}>Sem lista fixa: a fila segue por impacto em R$.</Typography>
        : <Typography sx={{ fontSize: 12.5, mb: 1 }}>Primeiro na fila (lista fixa): {r.lista_fixa.map((g) => `${g.nome} (${g.n_mlbs} MLBs)`).join(' · ')}</Typography>}
      <Stack spacing={0.75}>
        {Object.entries(r.contas).map(([uid, c]) => (
          <Box key={uid} sx={{ fontSize: 12.5, borderTop: 1, borderColor: 'divider', pt: 0.75 }}>
            <b>{NOME[uid] ?? uid}</b>
            {c.sem_janela_hoje ? <Box component="span" sx={{ color: LARANJA }}> — nenhuma relâmpago programada para hoje na Central de Promoções{c.sem_data ? ` (${c.sem_data} relâmpago(s) sem data na API)` : ''}</Box> : null}
            {c.janelas.map((j) => (
              <Typography key={j.janela} sx={{ fontSize: 12.5 }}>
                · janela <b>{rotuloJanela(j.janela)}</b> ({j.comeca === 'hoje' ? 'hoje' : 'amanhã'}): <b>{j.programadas}</b> programada(s) · {j.candidatas} candidata(s), {j.na_lista_fixa} na lista fixa
              </Typography>
            ))}
            <Typography sx={{ fontSize: 11.5, color: 'text.secondary' }}>
              {c.limite_observado != null
                ? `limite observado: ${c.limite_observado} relâmpago(s) por janela${c.ultima_recusa ? ` (última recusa do ML em ${c.ultima_recusa.slice(8, 10)}/${c.ultima_recusa.slice(5, 7)})` : ''} — o robô tenta uma a mais a cada rodada`
                : 'limite de vagas ainda não observado (o ML não documenta; o robô aprende na primeira recusa)'}
              {c.janelas_lidas_em ? ` · janelas lidas às ${new Date(c.janelas_lidas_em).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })}` : ' · janelas ainda não lidas (aguarda a próxima releitura/coleta)'}
              {c.janelas_erros.length ? ` · ⚠ ${c.janelas_erros.length} status sem resposta da API` : ''}
              {c.detalhe_arquivo ? '' : ' · detalhe cru da promoção ainda não salvo (1ª coleta completa)'}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Panel>
  )
}
